import { Component, EventEmitter, Output, input } from '@angular/core';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';

@Component({
  selector: 'pp-bulk-field-checkbox',
  templateUrl: './bulk-field-checkbox.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldCheckboxComponent {
  ppCustomField = input<TCustomField>(undefined);
  ppCustomFields = input<TBulkCustomFields<boolean>>(undefined);
  ppFieldId = input<string>(undefined);
  ppCustomFieldsExtended = input<TBulkCustomFieldsExtended<boolean>>(undefined);
  ppWorkspaceId = input<string>(undefined);
  ppDisabled = input<boolean>(false);

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;
  disabled = false;

  ngOnChanges(): void {
    this.disabled = this.ppDisabled() || this.ppCustomField()?.lockedValue;
  }

  updateCheckbox(value: boolean, field: TCustomField): void {
    if (this.ppCustomField().lockedValue) {
      return;
    }

    const customFields = this.ppCustomFields();
    customFields[field.id] = value;

    const ppCustomFieldsExtended = this.ppCustomFieldsExtended();
    ppCustomFieldsExtended[field.id] = {
      value: customFields[field.id],
      label: field.label,
      type: field.type,
    };

    this.ppCustomFieldsChange.emit(customFields);
    this.ppCustomFieldsExtendedChange.emit(ppCustomFieldsExtended);
  }
}
